import { render, staticRenderFns } from "./FooterFullBaNANA.vue?vue&type=template&id=0cfe3d4e&scoped=true"
import script from "./FooterFullBaNANA.vue?vue&type=script&lang=js"
export * from "./FooterFullBaNANA.vue?vue&type=script&lang=js"
import style0 from "./FooterFullBaNANA.vue?vue&type=style&index=0&id=0cfe3d4e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe3d4e",
  null
  
)

export default component.exports